import {
  MotorStepType,
  MotorFunnelState,
  MotorFlowDefinition,
  MotorFlowType,
} from 'scenes/motor/types';
import {
  isDirectDebitPayment,
  isCreditCardPayment,
  getPaymentFrequency,
} from 'scenes/motor/selectors';

export const forwardLinks: MotorFlowDefinition = {
  [MotorStepType.PaymentFrequency]: { step: MotorStepType.PaymentDate },
  [MotorStepType.PaymentDate]: { step: MotorStepType.PaymentMethod },
  [MotorStepType.PaymentMethod]: (funnelState: MotorFunnelState) => {
    if (isDirectDebitPayment(funnelState)) {
      return { step: MotorStepType.DirectDebitPayment };
    }
    if (isCreditCardPayment(funnelState)) {
      return { step: MotorStepType.CreditCardPayment };
    }
    return { step: MotorStepType.PaymentConfirmation };
  },
  [MotorStepType.DirectDebitPayment]: {
    step: MotorStepType.PaymentConfirmation,
  },
  [MotorStepType.CreditCardPayment]: {
    step: MotorStepType.PaymentConfirmation,
  },
  [MotorStepType.CreditCardPayment]: {
    step: MotorStepType.PaymentConfirmation,
  },
};

export const backwardLinks: MotorFlowDefinition = {
  [MotorStepType.PaymentFrequency]: (funnelState: MotorFunnelState) => ({
    step: MotorStepType.Summary,
    flow: MotorFlowType.PolicyDetails,
    [MotorFlowType.PolicyDetails]: {
      ...funnelState.policyDetails,
      preselectedPaymentFrequency: getPaymentFrequency(funnelState),
    },
  }),
  [MotorStepType.PaymentDate]: { step: MotorStepType.PaymentFrequency },
  [MotorStepType.PaymentMethod]: { step: MotorStepType.PaymentDate },
  [MotorStepType.DirectDebitPayment]: { step: MotorStepType.PaymentMethod },
  [MotorStepType.CreditCardPayment]: { step: MotorStepType.PaymentMethod },
  [MotorStepType.PaymentConfirmation]: {},
};
